export const PHONE_NUMBER_PROVIDER = {
  INTEGRATIONS_PLATFORM: 'INTEGRATIONS_PLATFORM',
  HUBSPOT: 'HUBSPOT',
  TWILIO: 'TWILIO'
};